import { lazy } from 'react';

const ResendEmails = lazy(() => import('./ResendEmails'));;

export default { ResendEmails };
